var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 73,
    viewBox: "0 0 77 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72.6257,
    height: 72.6257,
    rx: 8,
    fill: "#FFF1F3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3722,
    y: 27.5786,
    width: 21.4483,
    height: 21.4483,
    fill: "#E6386B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9558 46.7596H30.1274V42.0143L34.1948 44.413L36.2807 40.7628L32.2133 38.4162L36.2807 36.0696L34.1948 32.4194L30.1274 34.8181V30.0728H25.9558V34.8181L21.8884 32.4194L19.8025 36.0696L23.8699 38.4162L19.8025 40.7628L21.8884 44.413L25.9558 42.0143V46.7596ZM28.0416 62.4034C22.4446 57.6407 18.2646 53.2166 15.5015 49.1312C12.7371 45.0471 11.3549 41.2668 11.3549 37.7904C11.3549 32.5758 13.0326 28.4215 16.388 25.3275C19.742 22.2335 23.6266 20.6865 28.0416 20.6865C32.4566 20.6865 36.3412 22.2335 39.6952 25.3275C43.0506 28.4215 44.7283 32.5758 44.7283 37.7904C44.7283 41.2668 43.3468 45.0471 40.5838 49.1312C37.8193 53.2166 33.6386 57.6407 28.0416 62.4034Z",
    fill: "#FF99B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_68_1234)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.7283,
    y: 10.5732,
    width: 20.2256,
    height: 20.2256,
    rx: 10.1128,
    fill: "#FECBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.809 23.2669C53.809 22.2716 53.8982 21.5558 54.0766 21.1193C54.2546 20.6834 54.6323 20.2074 55.2098 19.6913C55.7135 19.249 56.0974 18.8649 56.3613 18.539C56.6257 18.2136 56.758 17.8421 56.758 17.4243C56.758 16.9205 56.5891 16.5028 56.2515 16.171C55.9133 15.8393 55.4432 15.6734 54.8412 15.6734C54.2145 15.6734 53.7383 15.8638 53.4124 16.2447C53.087 16.6256 52.8568 17.0127 52.7216 17.4059L50.8232 16.5949C51.0813 15.8085 51.5543 15.1266 52.2424 14.5491C52.9305 13.9716 53.7967 13.6829 54.8412 13.6829C56.1313 13.6829 57.1236 14.0424 57.8181 14.7614C58.5121 15.48 58.8591 16.343 58.8591 17.3506C58.8591 17.965 58.7271 18.4904 58.4632 18.9268C58.1988 19.3627 57.7839 19.8572 57.2187 20.4101C56.6167 20.9876 56.2512 21.4267 56.1225 21.7275C55.9932 22.0288 55.9286 22.5419 55.9286 23.2669H53.809ZM54.8412 27.6903C54.4357 27.6903 54.0887 27.546 53.8002 27.2575C53.5112 26.9685 53.3667 26.6213 53.3667 26.2158C53.3667 25.8103 53.5112 25.4631 53.8002 25.1741C54.0887 24.8856 54.4357 24.7413 54.8412 24.7413C55.2466 24.7413 55.5939 24.8856 55.8829 25.1741C56.1714 25.4631 56.3156 25.8103 56.3156 26.2158C56.3156 26.6213 56.1714 26.9685 55.8829 27.2575C55.5939 27.546 55.2466 27.6903 54.8412 27.6903Z",
    fill: "#E21E58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_68_1234",
    x: 32.7283,
    y: 10.5732,
    width: 44.2256,
    height: 44.2256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_68_1234"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_1234"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_68_1234"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_68_1234",
    result: "effect2_dropShadow_68_1234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_68_1234",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhere);
export default __webpack_public_path__ + "static/media/where.189996de540d2bf16a169734b0edeedc.svg";
export { ForwardRef as ReactComponent };